import React from 'react';
import { Card } from "@/components/ui/card";
import { Check, Circle } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface RMethodTrackerProps {
  currentStep: number; // 0-3
  steps: string[];
}

export const RMethodTracker: React.FC<RMethodTrackerProps> = ({ currentStep, steps: customSteps }) => {
  const defaultSteps = [
    'Recognise',
    'Reflect', 
    'Release',
    'Reprogramme'
  ];

  const steps = customSteps.length > 0 ? customSteps : defaultSteps;
  const progress = ((currentStep + 1) / steps.length) * 100;

  return (
    <Card className="p-4 bg-primary/5 border-primary/20">
      <div className="space-y-3">
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm font-medium text-foreground">Soulprint Sequence™ Progress</p>
          <p className="text-xs text-muted-foreground">
            Step {Math.min(currentStep + 1, steps.length)} of {steps.length}
          </p>
        </div>
        
        <Progress value={progress} className="h-2" />
        
        <div className="flex justify-between gap-2">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="flex flex-col items-center gap-1 flex-1"
            >
              <div className={`
                flex items-center justify-center w-8 h-8 rounded-full transition-all
                ${index <= currentStep 
                  ? 'bg-primary text-primary-foreground' 
                  : 'bg-muted text-muted-foreground'
                }
              `}>
                {index < currentStep ? (
                  <Check className="h-4 w-4" />
                ) : (
                  <Circle className="h-3 w-3" fill={index === currentStep ? 'currentColor' : 'none'} />
                )}
              </div>
              <p className={`
                text-xs text-center transition-all
                ${index <= currentStep ? 'text-foreground font-medium' : 'text-muted-foreground'}
              `}>
                {step}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};
